import styled from 'styled-components';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

export const Section = styled.section`
  padding: 4rem 2rem;
  background-color: ${props => props.theme.background};
  color: ${props => props.theme.text};
`;

export const SectionTitle = styled.h2`
  color: ${props => props.theme.primary};
  text-align: center;
  margin-bottom: 2rem;
  font-size: 2.5rem;
`;

export const StyledCard = styled.div`
  background: ${props => props.theme.cardBackground};
  border-radius: 12px;
  box-shadow: 0 2px 8px ${props => props.theme.shadow};
  border: 2px solid ${props => props.theme.primary};
  padding: 2rem 1.5rem;
  text-align: center;
  margin: 1rem;
  transition: all 0.3s ease;
  cursor: pointer;
  height: 100%;
  overflow: hidden;
  z-index: 0;
  color: ${props => props.theme.text};

  &:hover {
    background: ${props => props.theme.primaryDark};
    border-color: ${props => props.theme.primaryDark};
    color: white;
  }
`;

export const ProcessCard = styled(StyledCard)`
  &:hover * {
    color: white !important;
    transition: color 0.3s;
  }
`;

export const ProcessStep = styled.div`
  text-align: center;
  padding: 2rem;
  color: ${props => props.theme.text};
  
  h3 {
    color: ${props => props.theme.primary};
    margin-bottom: 1rem;
  }
`;

export const PricingCard = styled(StyledCard)`
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
  
  .pricing-image {
    width: calc(100% - 16px);
    height: 200px;
    object-fit: cover;
    margin: 8px;
    border-radius: 8px;
    transition: transform 0.3s ease;
  }

  .pricing-content {
    padding: 1rem;
    margin-top: -8px;
  }

  h3 {
    color: ${props => props.theme.primary};
    margin-bottom: 0.75rem;
    transition: color 0.3s;
  }

  ul {
    list-style: disc;
    padding-left: 1.25rem;
    margin: 0;
    color: ${props => props.theme.text};
    
    li {
      margin: 0.25rem 0;
      transition: color 0.3s;
      text-align: left;
    }
  }

  &:hover {
    h3,
    li {
      color: white !important;
    }
    .pricing-image {
      transform: scale(1.02);
    }
  }
`;

export const FAQAccordion = styled(Accordion)`
  background-color: ${props => props.theme.cardBackground};
  box-shadow: none;
  border: 1px solid ${props => props.theme.primary};
  margin-bottom: 1rem;
  border-radius: 8px !important;
  overflow: hidden;
  color: ${props => props.theme.text};

  &:before {
    display: none;
  }

  .MuiAccordionSummary-root {
    background-color: ${props => props.theme.primary};
    color: white !important;
    padding: 0.75rem 1.5rem;
    min-height: unset !important;
    height: auto !important;
    transition: background-color 0.3s;
    
    &:hover {
      background-color: ${props => props.theme.primaryDark};
    }

    &.Mui-expanded {
      min-height: unset !important;
      height: auto !important;
    }

    .MuiTypography-root {
      color: white !important;
    }
  }

  .MuiAccordionSummary-content {
    margin: 0.75rem 0 !important;
    display: flex;
    align-items: center;
  }

  .MuiAccordionDetails-root {
    padding: 1.5rem;
  }

  @media (max-width: 600px) {
    .MuiAccordionSummary-root {
      padding: 0.5rem 1rem;
    }
    
    .MuiAccordionSummary-content {
      margin: 0.5rem 0 !important;
    }

    .MuiTypography-h6 {
      font-size: 1rem;
      line-height: 1.4;
      color: white !important;
    }
  }
`;

export const StyledAccordionSummary = styled(AccordionSummary)`
  && {
    background-color: ${props => props.theme.primary};
    color: white !important;
    padding: 0.75rem 1.5rem;
    min-height: unset !important;
    height: auto !important;
    transition: background-color 0.3s;
    
    &:hover {
      background-color: ${props => props.theme.primaryDark};
    }

    &.Mui-expanded {
      min-height: unset !important;
      height: auto !important;
    }

    .MuiTypography-root {
      color: white !important;
    }
  }
`;

export const StyledAccordionDetails = styled(AccordionDetails)`
  && {
    padding: 1.5rem;
  }
`;

export const WelcomeSection = styled.section`
  position: relative;
  min-height: 350px;
  background-image: url(${props => props.backgroundImage});
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
  overflow: hidden;
  &::before {
    content: "";
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.5);
    z-index: 1;
  }
`;

export const WelcomeContent = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 3rem 1rem;
`; 